import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { variables } from './Variables.js';
import MainSportList_Ar from './MainSportList_Ar.js';
export default function SportList_Ar() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_BusFinance.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 0; i <= 4 && i < response.data.length; i++) {
          JsonArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),

            Category: response.data[i].Category,
          })
        }
      })
  }
  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  return (
    <>
      <div className="post-sports-box mt-40">
        <div className="section-title">
          <h3 className="title float-right">المال و الأعمال  </h3>
          <br></br>
        </div>
        <MainSportList_Ar />
        {JsonArray.map(da =>
          <div key={da.news_title}  >
            <div className="post_gallery_items">
              <div className="post-gallery-style-2">
                <div className="post-gallery-thumb">
                  <a href={da.link}>
                    <img style={{ maxWidth: '100%', maxHeight: '57px', minHeight: '57px' }} className='rounded ' src={da.news_imagename} alt="gallery" />
                  </a>
                </div>
                <div className="post-gallery-content">
                  <h5 className="title "><a href={da.link}>{da.news_title}</a></h5>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}



